// extracted by mini-css-extract-plugin
export default {"dealerDetailWrapper":"u01iEoDd3d"};